import usePrevious from './usePrevious';

export default function useHasChanged<T>(val: T): boolean {
  const prevVal = usePrevious(val);
  return prevVal !== val;
}
